import { computed, h, defineComponent } from 'vue';
import { SelectionBox } from '@/ui/components/SelectionBox';
import { t } from '@/ui/i18n/i18n';
import { monetizeString, parseInt10 } from '@/ui/helpers';
import { currency, monthlyPrice, planType, yearlyPrice } from '@/services/chargebee/availablePlans';
import { ProductInterval } from '@/entities/chargebee/product/constants';

export const BoxSelectionsCb = defineComponent({
  setup() {
    const isYearlyPlanSelected = computed(() => planType.value === ProductInterval.Year);
    const updatePlanFrequency = (value: ProductInterval) => {
      planType.value = value;
    };

    return function render() {
      const monthlyBox = h(SelectionBox, {
        props: {
          value: planType.value,
          name: 'planType',
          nativeValue: ProductInterval.Month,
          active: !isYearlyPlanSelected.value,
        },
        on: {
          click: () => updatePlanFrequency(ProductInterval.Month),
        },
      }, [
        h('div', { slot: 'radioDefault' }, [
          h('span', t('subscription.monthly')),
        ]),
        h('div', { slot: 'boxDefault' }, [
          h('span',
            { class: 'subscribe_page__price' },
            monthlyPrice.value ? monetizeString(monthlyPrice.value, { beginning: false, currency: currency.value }) : '0'),
          h('span', { class: 'ml-2' }, t('subscription.month/user')),
        ]),
      ]);
      const yearlyBox = h(SelectionBox, {
        props: {
          value: planType.value,
          name: 'planType',
          nativeValue: ProductInterval.Year,
          active: isYearlyPlanSelected.value,
        },
        on: {
          click: () => updatePlanFrequency(ProductInterval.Year),
        },
      }, [
        h('div', { slot: 'radioDefault' }, [
          h('span', t('subscription.yearly')),
          h('span', { class: 'subscribe_page__save' }, t('subscription.save', { percentage: '20' })),
        ]),
        h('div', { slot: 'boxDefault' }, [
          h(
            'span',
            { class: 'subscribe_page__price' },
            yearlyPrice.value ? monetizeString((parseInt10(yearlyPrice.value) / 12).toFixed(2), { beginning: false, currency: currency.value }) : '0',
          ),
          h('span', { class: 'ml-2' }, t('subscription.month/user')),
        ]),
      ]);

      return h('div', { class: 'subscribe_page__selection-box-row' }, [yearlyBox, monthlyBox]);
    };
  },
});
